import {BaseModel} from 'sjs-base-model';

export default class UserModel extends BaseModel {
  userName = '';
  firstname = '';
  lastname = '';
  email = '';
  mobile = '';

  constructor(data) {
    super();
    this.update(data);
  }
}
